import DesktopAppProvider from './DesktopApp.provider';

export default DesktopAppProvider;
